export const toCurrency = (price, pre_string = "", post_string = "") => {
  if (isNaN(price) || price === 0) return "";
  const isWhole = price % 1 === 0;
  return `${pre_string}$${isWhole ? price : price.toFixed(2)}${post_string}`;
};
